jQuery(function ($) {
  $('a[rel~=popover], .has-popover').popover();
  $('a[rel~=tooltip], .has-tooltip').tooltip();
});



// WEBPACK FOOTER //
// ./bootstrap.js